import React, { Component } from 'react';
import { LinkContainer } from 'react-router-bootstrap';
import { Row, Col, Form, FormGroup, FormControl, ControlLabel, Button } from 'react-bootstrap'
import Api from './../../../Global/Modules/Api'

const FETCH_URL = "api/auth/user/"

class AccountEdit extends Component {
    constructor(props) {
        super(props)
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleChange = this.handleChange.bind(this)
        this.state = {
            data: {
                id: "",
                userName: "",
                password: "",
                roleId: ""
            },
            rePassword: "",
            errors: {}
        }
    }

    getAccountDetail(id) {
        Api.GetApi(FETCH_URL + id, this.props.history).then(account => {
            Api.print(`Detail of account ${id}`)
            Api.print(account)
            Api.print("----------")


            if (account !== undefined)
                this.setState({ data: { ...this.state.data, id: id, userName: account.userName, roleId: account.roleId } })

            Api.print(this.state.data)
        })
    }

    componentDidMount() {
        this.getAccountDetail(this.props.id)
    }

    // Function that will be executed when the submit button (Toevoegen) is pressed
    handleSubmit(event) {
        event.preventDefault()
        Api.print("Data to send")
        Api.print(this.state.data)
        Api.print("---------------")

        if (this.state.data.password !== this.state.rePassword)
            this.setState({ errors: { password: 'Passwords do not match' } })

        else {
            Api.PostApi(FETCH_URL, this.state.data, this.props.history)
                .then(response => {
                    Api.print("Response")
                    Api.print(response)
                    Api.print(("---------------"))
                    if (response !== undefined && response.password != undefined) {
                        this.setState({ errors: response });
                    }
                    else {
                        alert("Account updated")
                        window.location.href = "/admin/accounts";
                        // TODO: Show message OK
                    }
                })
        }
    }

    // Function to manage the changes of the text fields and selects
    handleChange(event) {
        const target = event.target
        const name = target.name
        const value = target.value

        if (name === "roleId") this.setState({ data: { ...this.state.data, [name]: parseInt(value) } })
        else name === "rePassword" ? this.setState({ [name]: value }) : this.setState({ data: { ...this.state.data, [name]: value } })

    }

    render() {
        let data = this.state.data
        let rePassword = this.state.rePassword
        let errors = this.state.errors
        return (
            <div>
                <Row>
                    <Form horizontal onSubmit={this.handleSubmit}>
                        <Col md={12}>Password requirements:</Col>
                        <Col md={12}>Must be at least 6 characters.</Col>
                        <Col md={12}>Must have at least one lowercase ('a'-'z') and at least one uppercase ('A'-'Z')</Col>
                        <Col md={12}>Must have at least one digit ('0'-'9').</Col>
                        <Col md={12}>Must have at least one non alphanumeric character.</Col>
                        <Col md={12}>
                            <FormGroup controlId="AccountTitel">
                                <Col componentClass={ControlLabel} sm={4}>
                                    Naam *
                            </Col>
                                <Col sm={6}>
                                    {/**<FormControl type="text" placeholder="" defaultValue="admin"/>**/}
                                    <FormControl type="text" name="userName" value={data.userName} required onChange={this.handleChange} />
                                    {Api.showError(errors, "userName")}
                                </Col>
                            </FormGroup>
                            <FormGroup controlId="AccountPassword">
                                <Col componentClass={ControlLabel} sm={4}>
                                    Wachtwoord *
                            </Col>
                                <Col sm={6}>
                                    {/**<FormControl type="password" placeholder="" defaultValue="xxxxxxx"/>**/}
                                    <FormControl type="password" name="password" value={data.password} required onChange={this.handleChange} />
                                    {Api.showError(errors, "password")}
                                </Col>
                            </FormGroup>

                            <FormGroup controlId="AccountPasswordCheck">
                                <Col componentClass={ControlLabel} sm={4}>
                                    Wachtwoord  controle *
                            </Col>
                                <Col sm={6}>
                                    {/**<FormControl type="password" placeholder=""  defaultValue="xxxxxxx"/>**/}
                                    <FormControl type="password" name="rePassword" value={rePassword} required onChange={this.handleChange} />
                                    {Api.showError(errors, "password")}
                                </Col>
                            </FormGroup>

                            <FormGroup controlId="AccountRole">
                                <Col componentClass={ControlLabel} sm={4}>
                                    Rol *
                            </Col>
                                <Col sm={6}>
                                    <FormControl componentClass="select" name="roleId" value={data.roleId} required onChange={this.handleChange}>
                                        <option value="">-- kies rol --</option>
                                        {Api.getAccountRoles().map((roleId, index) =>
                                            <option
                                                value={index + 1}
                                                key={"roleId" + index}>
                                                {roleId}
                                            </option>
                                        )}
                                    </FormControl>
                                    {Api.showError(errors, "roleId")}
                                </Col>
                            </FormGroup>

                        </Col>
                        <Col md={12}>
                            <FormGroup>
                                <Col sm={12}>
                                    <LinkContainer to="/admin/accounts"><Button type="button" className="pull-left">Annuleren</Button></LinkContainer>
                                    <Button type="submit" className="pull-right">Wijzigen</Button>
                                </Col>
                            </FormGroup>
                        </Col>
                    </Form>
                </Row>
            </div>
        );
    }
}

export default AccountEdit;


// WEBPACK FOOTER //
// ./src/components/Admin/Modules/Accounts/Edit.js